import React from 'react';
import { ImportantBenefitTypes } from '.';
import { CallToActionButton } from '../../../../components/ctaButton/CTAButton';
import { Row } from '../../../../components/row/Row';

const TextSection = ({
  title,
  description,
  callToAction,
  theme = 'light',
}: ImportantBenefitTypes.ITextSection) => {
  const textColor = theme === 'light' ? 'black' : 'white';
  return (
    <>
      <Row className="flex-1 is-justify-content-center">
        <div className="textContainers">
          <h3 className={`py-2 has-text-centered has-text-${textColor}`}>
            {title}
          </h3>
          <p className={`py-4 has-text-centered has-text-${textColor}`}>
            {description}
          </p>
        </div>
      </Row>

      {callToAction && callToAction.show && (
        <CallToActionButton {...callToAction} theme={theme} type="primary" />
      )}
    </>
  );
};

export default TextSection;
